// https://nuxt.com/docs/guide/directory-structure/app-config
export default defineAppConfig({
});